<template>
  <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
      <a-card title="Financing Detail">
        <a-form-model ref="detailForm" :model="form" :rules="rules">
          <a-form-model-item label="Jangka Waktu" prop="jkw_start">
            <a-range-picker
              :format="getDefaultDateFormat"
              v-model="form.jkw_start"
            />
          </a-form-model-item>
          <a-form-model-item label="Jumlah Fasilitas" prop="jml_fasilitas">
            <a-input-number
              :min="0"
              class="m-width-full m-text-align right"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-model="form.jml_fasilitas"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Provisi" prop="provisi">
            <a-input-number
              :min="0"
              class="m-width-full m-text-align right"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-model="form.provisi"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Biaya Administrasi" prop="biaya_admin">
            <a-input-number
              :min="0"
              class="m-width-full m-text-align right"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-model="form.biaya_admin"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Financing Type" prop="type_financing">
            <a-radio-group
              :disabled="getFinanceHutang.length > 0 || mode == 'Edit'"
              v-model="form.type_financing"
              button-style="solid"
            >
              <a-radio-button value="FK"> KMK </a-radio-button>
              <a-radio-button value="FP"> Non KMK </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-form-model>
      </a-card>
    </a-col> -->
  <a-card title="Detail Payment">
    <a-row :gutter="12">
      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-alert :class="getScreen ? 'margin-bottom' : ''" :type="sisa_penarikan == 0 ? 'success' : 'error'" show-icon>
          <span slot="message">{{ formatCurrency("", sisa_penarikan) }}</span>
          <span slot="description"
            >Sisa jumlah fasilitas yang belum dijadwalkan</span
          >
        </a-alert>
        <a-form-model ref="hutangForm" :model="form" :rules="rules">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-model-item label="Month" prop="bulan">
                <a-month-picker
                  v-model="form.bulan"
                  format="MMMM"
                  placeholder="Select month"
                ></a-month-picker>
              </a-form-model-item>
              <!-- <a-form-model-item label="Date" prop="date">
                      <a-date-picker
                        :format="getDefaultDateFormat"
                        v-model="form.date"
                      />
                    </a-form-model-item> -->
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-model-item label="Year" prop="tahun">
                <a-date-picker
                  v-model="form.tahun"
                  mode="year"
                  format="YYYY"
                  :open="yearPicker.isOpen"
                  @panelChange="
                    (v) => {
                      yearPicker.isOpen = false;
                      form.tahun = v;
                    }
                  "
                  @openChange="
                    !yearPicker.isOpen
                      ? (yearPicker.isOpen = true)
                      : (yearPicker.isOpen = false)
                  "
                  placeholder="Select year"
                ></a-date-picker>
              </a-form-model-item>
              <!-- <a-form-model-item label="File Document" prop="doc_financing_dtl">
                      <template v-if="isEdit">
                        <div class="doc-viewer edit">
                          <div class="detail">
                            <a-button-group size="small">
                              <a-upload
                                accept="*"
                                :showUploadList="false"
                                :beforeUpload="beforeUpload"
                              >
                                <a-button size="small" icon="upload">
                                  Change File
                                </a-button>
                              </a-upload>
                              <a-button
                                @click="handleRevert"
                                type="primary"
                                v-if="form.doc_financing_dtl"
                                icon="reload"
                              ></a-button>
                            </a-button-group>
                            <h4 class="margin-remove m-text-dots">
                              {{
                                this.form.doc_financing_dtl == null
                                  ? this.form.doc_existing_dtl
                                  : this.form.doc_financing_dtl.name
                              }}
                            </h4>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <a-upload
                          accept=".pdf"
                          :showUploadList="false"
                          :beforeUpload="beforeUpload"
                        >
                          <div class="upload">
                            <a-button icon="upload">Select File </a-button>
                          </div>
                        </a-upload>
                        <div
                          class="doc-viewer"
                          v-if="form.doc_financing_dtl !== null"
                        >
                          <a-button
                            type="danger"
                            ghost
                            size="small"
                            class="close"
                            icon="close"
                            @click="removeUploadFile()"
                          ></a-button>
                          <div class="detail">
                            <h4 class="margin-remove m-text-dots">
                              {{
                                JSON.parse(
                                  JSON.stringify(form.doc_financing_dtl.name)
                                )
                              }}
                            </h4>
                          </div>
                        </div>
                      </template>
                    </a-form-model-item> -->
            </a-col>
          </a-row>
          <a-form-model-item label="Principal of Payment" prop="pokok">
            <a-input-number
              :min="0"
              :initialValue="0"
              class="m-width-full m-text-align right"
              :formatter="
                (value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="form.pokok"
            ></a-input-number>
          </a-form-model-item>
          <a-form-model-item label="Bank Interest" prop="bunga">
            <a-input-number
              :min="0"
              :initialValue="0"
              class="m-width-full m-text-align right"
              :formatter="
                (value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
              v-model="form.bunga"
            ></a-input-number>
          </a-form-model-item>
          <a-button-group class="action">
            <a-button
              type="primary"
              :block="changeDetail.status ? false : true"
              :icon="changeDetail.status ? '' : 'plus'"
              @click="handleSubmit"
              >{{ changeDetail.status ? "Submit Change" : "Add Detail" }}
            </a-button>
            <a-button
              v-if="changeDetail.status"
              @click="handleCancelEdit"
              icon="close"
              type="default"
              >Cancel</a-button
            >
          </a-button-group>
        </a-form-model>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-table
          bordered
          :data-source="getFinanceHutang"
          :pagination="false"
          :columns="columns"
          :scroll="{ x: 800 }"
        >
          
          <span slot="no" slot-scope="item,record, index">
            {{index + 1}}
          </span>
          <span slot="monthyear" slot-scope="item">
            {{
              moment()
                .month(parseInt(item.bulan) - 1)
                .format("MMMM") +
                " - " +
                moment(item.tahun).format("YYYY")
            }}
          </span>
          <span slot="total" slot-scope="item">
            <CurrencyJustified
              :currencyValue="'IDR'"
              :valueNumber="Number(item)"
            />
          </span>
          <span slot="bunga" slot-scope="item">
            <CurrencyJustified
              :currencyValue="'IDR'"
              :valueNumber="Number(item)"
            />
          </span>
          <span slot="pokok" slot-scope="item">
            <CurrencyJustified
              :currencyValue="'IDR'"
              :valueNumber="Number(item)"
            />
          </span>
          <a-button-group slot="action" slot-scope="item">
            <a-button
              @click="handleEdit(item)"
              icon="edit"
              :disabled="item.delete_button == 'disabled'"
            />
            <a-button
              @click="handleRemove(item)"
              :disabled="changeDetail.selected.id == item.id || item.delete_button == 'disabled'"
              icon="delete"
              type="danger"
            />
          </a-button-group>
          <ul class="table-footer" slot="footer">
            <li>
              <span>Total Principal of Payment</span>
              <h3>{{ formatCurrency("IDR", sum_table_pokok) }}</h3>
            </li>
            <li>
              <span>Total Bank Interest</span>
              <h3>{{ formatCurrency("IDR", sum_table_bunga) }}</h3>
            </li>
            <li>
              <span>Grand Total </span>
              <h3>{{ formatCurrency("IDR", sum_table_total) }}</h3>
            </li>
          </ul>
        </a-table>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import nanoid from "nanoid";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "financing",
  props: {
    dataProcessed: {},
    mode: String,
    type: String,
  },
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    const columns = [
      {
        title: "No",
        key: "key",
        align: "center",
        scopedSlots: { customRender: "no" },
        width: 70,
      },
      {
        title: "Month-Year",
        key: "monthyear",
        scopedSlots: { customRender: "monthyear" },
        width: 150,
      },
      {
        title: "Principal of Payment",
        key: "principalofpayment",
        dataIndex: "pokok",
        scopedSlots: { customRender: "pokok" },
        align: "right",
        width: 170,
      },
      {
        title: "Bank Interest",
        key: "bankInterest",
        dataIndex: "bunga",
        scopedSlots: { customRender: "bunga" },
        align: "right",
        width: 170,
      },
      {
        title: "Total Value",
        key: "totalValue",
        dataIndex: "total",
        scopedSlots: { customRender: "total" },
        align: "right",
        width: 170,
      },
      {
        title: "Action",
        key: "action",
        scopedSlots: { customRender: "action" },
        width: 100,
        align: "center",
        fixed: "right",
      },
    ];
    let doc_validation = (rule, value, callback) => {
      if (!this.isEdit && this.form.doc_financing_dtl == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    let rangeDT_validation = (rule, value, callback) => {
      if (value[0] == null || value[1] == null) {
        callback(new Error("Please select date!"));
      } else {
        callback();
      }
    };
    return {
      columns,
      form: {
        jkw_start: null,
        jml_fasilitas: null,
        provisi: null,
        biaya_admin: null,
        type_financing: "FK",
        bulan: null,
        tahun: null,
        pokok: null,
        bunga: null,
        date: null,
        value: null,
        doc_financing_dtl: null,
        list_fk: [],
      },
      rules: {
        jkw_start: {
          required: true,
          validator: rangeDT_validation,
          message: "Please select date",
          trigger: "blur",
        },
        jml_fasilitas: [
          {
            required: true,
            message: "Please Input Jumlah Fasilitas",
            trigger: "blur",
          },
          { validator: this.validRatherThenzero },
        ],
        provisi: [
          { required: true, message: "Please Input Provisi", trigger: "blur" },
          { validator: this.validRatherThenzero },
        ],
        biaya_admin: [
          {
            required: true,
            message: "Please Input Biaya Administrasi",
            trigger: "blur",
          },
          { validator: this.validRatherThenzero },
        ],
        type_financing: {
          required: true,
          message: "Please Pick Financing Type",
          trigger: "change",
        },
        bulan: {
          required: true,
          message: "Please Insert No Kontrak",
          trigger: "change",
        },
        tahun: {
          required: true,
          message: "Please Insert value",
          trigger: "change",
        },
        date: {
          required: true,
          message: "Please Pick a Date",
          trigger: "change",
        },
        pokok: {
          required: true,
          message: "Please Input Principal of Payment",
          trigger: "change",
        },
        bunga: {
          required: true,
          message: "Please Input Bank Interest",
          trigger: "change",
        },
        doc_financing_dtl: [{ validator: doc_validation, trigger: "change" }],
      },
      changeDetail: {
        selected: {},
        status: false,
      },
      isEdit: false,
      valueEdit: 0,
      yearPicker: {
        isOpen: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getFinanceHutang",
      "getFinanceDetail",
      "getInformationFinancing",
      "getScreen"
    ]),
    sum_table_total() {
      let output = this.getFinanceHutang;
      const sum = output.reduce((sum, item) => sum + parseInt(item.total), 0);

      return sum;
    },
    sum_table_pokok() {
      let output = this.getFinanceHutang;
      const sum = output.reduce((sum, item) => sum + parseInt(item.pokok), 0);

      return sum;
    },
    sum_table_bunga() {
      let output = this.getFinanceHutang;
      const sum = output.reduce((sum, item) => sum + parseInt(item.bunga), 0);

      return sum;
    },
    sisa_penarikan() {
      let output =
        parseFloat(this.getInformationFinancing.jml_fasilitas) -
        this.sum_table_pokok;
      return output;
    },
  },
  mounted() {
    this.initialData();
  },
  methods: {
    moment,
    initialData() {
      this.form = {
        ...this.form,
        jkw_start: [
          this.getFinanceDetail.jkw_start_dt,
          this.getFinanceDetail.jkw_end_dt,
        ],
        jml_fasilitas: this.getFinanceDetail.jml_fasilitas,
        provisi: this.getFinanceDetail.provisi,
        biaya_admin: this.getFinanceDetail.biaya_admin,
        type_financing: this.getFinanceDetail.type_financing,
      };
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 30) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.form.doc_financing_dtl = file;
        return false;
      }
    },
    handleSubmit() {
      this.$refs.hutangForm.validate((valid) => {
        if (!valid) {
          this.displayMessageValue(
            "basic-error",
            "Please complete Detil payment form"
          );
          return;
        }

        let data = {
          id: this.changeDetail.status
            ? this.changeDetail.selected.id
            : nanoid(),
          bulan: moment(this.form.bulan).format("M"),
          tahun: moment(this.form.tahun).format("YYYY"),
          pokok: this.form.pokok,
          bunga: this.form.bunga,
          total: parseFloat(this.form.pokok) + parseFloat(this.form.bunga),
        };

        if (this.form.pokok < 1 && this.form.bunga < 1) {
          this.displayMessageValue(
            "basic-error",
            "Total Principal of Payment and Bank Interest Cannot less than 0, please fill in one!"
          );
          return;
        }

        if (this.changeDetail.status) {
          if (
            this.sisa_penarikan +
              this.changeDetail.selected.pokok -
              parseFloat(this.form.pokok) <
            0
          ) {
            this.displayMessageValue(
              "basic-error",
              "Total Principal of Payment must be less or equal then Number of Facilities!"
            );
            return;
          }
          this.$store.commit("editHutang", data);
          this.displayMessage("success-edit");
          this.handleCancelEdit();
        } else {
          if (this.sisa_penarikan - parseFloat(this.form.pokok) < 0) {
            this.displayMessageValue(
              "basic-error",
              "Total Principal of Payment must be less or equal then Number of Facilities!"
            );
            return;
          }
          this.$store.commit("setFinanceHutang", data);
        }

        this.$refs.hutangForm.resetFields();
      });
    },
    handleRemove(item) {
      if (this.changeDetail.status) {
        this.displayMessageValue(
          "basic-error",
          "complete your changing data first!"
        );
        return;
      }

      this.$store.commit("removeHutang", item);
    },
    handleView(item) {
      if (this.mode == "Create") {
        this.handlePDF(item.doc_financing_dtl);
      } else {
        if (item.doc_financing_dtl == null) {
          window.open(this.$serviceUrl + item.url);
        } else {
          this.handlePDF(item.doc_financing_dtl);
        }
      }
    },
    removeUploadFile() {
      this.form.doc_financing_dtl = null;
    },
    handleRef() {
      if (this.changeDetail.status) {
        this.displayMessageValue(
          "basic-error",
          "complete your changing data first!"
        );
        return;
      }

      if (this.sisa_penarikan !== 0) {
        this.displayMessageValue(
          "basic-error",
          "Please create more detail payment or Remaining number of facilities must be 0"
        );
        return;
      }

      if (this.getFinanceHutang.length == 0) {
        this.displayMessage("form-warning");
        return;
      }
      
      Event.$emit("dataProcessed", this.getFinanceHutang);
    },
    handleEdit(item) {
      this.changeDetail = {
        selected: item,
        status: true,
      };

      this.form = {
        bulan: this.moment().month(parseFloat(item.bulan - 1)),
        tahun: item.tahun,
        pokok: item.pokok,
        bunga: item.bunga,
      };
    },
    handleCancelEdit() {
      this.$refs.hutangForm.resetFields();
      this.valueEdit = 0;
      this.changeDetail = {
        selected: {},
        status: false,
      };
    },
    handleRevert() {
      this.form.doc_financing_dtl = null;
    },
  },
};
</script>

<style lang="less" scoped>
.ant-table-thead > tr > th {
  text-align: center;
}
.action {
  margin: 12px 0;
}

.table-footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  list-style: none;
  text-align: right;
}

.doc-viewer {
  margin-top: 0.5em;
  border: 1px solid darken(white, 10);
  border-radius: 5px;
  padding: 5px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background-color: darken(white, 2);
  position: relative;
  cursor: pointer;
  transition: all ease-in-out 0.2s;
  &:hover {
    border-color: @color-primary;
  }

  &.edit {
    align-items: center;
    padding: 5px;
    min-height: auto;
    .detail {
      flex: 1;
      flex-direction: row;
      justify-content: space-between;
      h4 {
        text-align: right;
      }
    }
  }

  .icon {
    font-size: 3.5em;
    color: orangered;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.5em;
    h4,
    small {
      text-transform: capitalize;
    }
  }

  .close {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
  }
}
</style>
